/**
 * Escapes the five characters that let a string break out of HTML text or
 * attribute context. Ampersand is replaced first, otherwise the entities
 * introduced by the later replacements get escaped a second time.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
